
export function checkMobile(rule, value, callback) {
  if (value == null || value.trim() === '') {
    if (rule.required) {
      callback(new Error('请输入手机号'))
    } else {
      callback()
    }
    return
  }
  let re = /^[0-9]{11}$/;
  var result = re.test(value); 
  if(!result) {
    callback(new Error('请输入正确的手机号'))
  } else {
    callback()
  }
}

export function checkPhone(rule, value, callback) {
  //手机号：13，14，15，17，18，19号段
  const phoneReg = /^1[3|4|5|7|8][0-9]{9}$/
  //固话：区号(3-4位)-号码(7-9位)
  const mobReg =  /(^[0-9]{3,4}-[0-9]{7,9}$)/
  //澳门电话号码: 28开头，后面跟6位数字，区号为853
  const macaoMobReg = /^(853)?28\d{6}$/
  //澳门手机号码：6开头，后面跟7位数字，区号为853
  const macaoPhoneReg = /^(853)?6\d{7}$/
  //同时支持手机号码和电话号码
  const macaoReg = /^(853)?(?:28\d{6}|6\d{7})$/  
  if (!value) {
      callback(new Error('电话号码不能为空'))
  } else if (phoneReg.test(value)||mobReg.test(value)||macaoReg.test(value)) {
      callback()
  } else {
      callback(new Error('请输入正确电话号码'))
  }
}

export function loginNameRule (rule, value, callback) {
  if (value == null || value.trim() === '') {
    if (rule.required) {
      callback(new Error('请输入账号'))
    } else {
      callback()
    }
    return
  }
  let re =/^[\u4e00-\u9fa5a-zA-Z0-9]+$/
  var result = re.test(value)
  if(!result) {
    callback(new Error('请输入正确的账号'))
  } else {
    callback()
  }
}

export function nameRule (rule, value, callback) {
  if (value == null || value.trim() === '') {
    if (rule.required) {
      callback(new Error('请输入名字'))
    } else {
      callback()
    }
    return
  }
  callback()
}
export function creditCode (rule, value, callback) {
  if (value == null || value.trim() === '') {
    if (rule.required) {
      callback(new Error('请输入社会信用代码'))
    } else {
      callback()
    }
    return
  }
  let re = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/
  var result = re.test(value)
  if(!result) {
    callback(new Error('请输入正确的社会信用代码'))
  } else {
    callback()
  }
}

// 验证邮箱
export function checkEmail (rule, value, callback) {
  if (value == null || value.trim() === '') {
    callback()
    return
  }
  if (!/^\S+@\S+\.\S+$/.test(value)) {
    callback(new Error('邮箱格式不正确'))
    return
  }
  callback()
}
